export const giveawaysQueryKeys = {
    giveawayQueryKeySelector: (giveawayId) => ['giveaways', giveawayId],
    giveawaysQueryKeySelector: () => ['giveaways'],
    giveawaysPagedQueryKeySelector: () => ['giveaways-paged'],
    giveawaysStatisticsQueryKeySelector: () => ['giveaways', 'statistics'],
    giveawaysSchedulerQueryKeySelector: () => ['giveaways', 'scheduler'],
    giveawaysVouchersCount: () => ['giveaways', 'vouchers', 'count'],
};
export const giveawaysMutationKeys = {
    createGiveawayMutationKeySelector: () => ['giveaways', 'create'],
    updateGiveawaysSchedulerMutationKeySelector: () => ['giveaways', 'scheduler', 'update'],
    deleteGiveawaysSchedulerMutationKeySelector: () => ['giveaways', 'scheduler', 'delete'],
    createGiveawaysSchedulerMutationKeySelector: () => ['giveaways', 'scheduler', 'create'],
};
